import { FC } from 'react';
import { getPrBannerProps } from '@doda/common/src/logics/jobSearchList/getPrBannerProps';
import { SeoNarrowDownButton } from 'components/SeoNarrowDownButton';
import { BodyTitle } from '../BodyTitle';
import styles from '../../screens/index.module.scss';
import { PrBanner } from '../PrBanner';
import { ListControls } from '../ListControls';
import { PrefOnlyButton } from '../PrefOnlyButton';
import { PageProps } from '../../index.page';
import { usePrefOnlyButton } from '../PrefOnlyButton/hooks/usePrefOnlyButton';

/**
 * BodyHeaderのProps
 * @param prBannerData PRバナーデータ
 * @param explainText タイトル下説明文
 */
interface Props {
  prBannerData: PageProps['prBannerData'];
  explainText: PageProps['explainText'];
  seoNarrowDownButtonData: PageProps['seoNarrowDownButtonData'];
}

export const BodyHeader: FC<Props> = ({
  prBannerData,
  explainText,
  seoNarrowDownButtonData,
}) => {
  const { prBannerLinkUrl, prBannerImagePath, prBannerJobText } =
    getPrBannerProps(prBannerData);
  const isShowPrBanner = !!(
    prBannerLinkUrl &&
    prBannerImagePath &&
    prBannerJobText
  );
  const { isShowPrefOnlyButton } = usePrefOnlyButton();

  return (
    <div>
      <BodyTitle explainText={explainText} />
      {isShowPrBanner && (
        <div className={styles.jobSearchList__prBannerWrap}>
          <PrBanner
            prBannerLinkUrl={prBannerLinkUrl}
            prBannerImagePath={prBannerImagePath}
            prBannerJobText={prBannerJobText}
          />
        </div>
      )}
      <ListControls />
      <SeoNarrowDownButton seoNarrowDownButtonData={seoNarrowDownButtonData} />
      {isShowPrefOnlyButton && (
        <div className={styles.jobSearchList__prefOnly}>
          <PrefOnlyButton />
        </div>
      )}
    </div>
  );
};
